module.exports = __webpack_public_path__ + "static/media/tanda-logo.3a1eff06.svg";